/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./director.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./director.component";
var styles_DirectorComponent = [i0.styles];
var RenderType_DirectorComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DirectorComponent, data: {} });
export { RenderType_DirectorComponent as RenderType_DirectorComponent };
export function View_DirectorComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" director works!\n"]))], null, null); }
export function View_DirectorComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-director", [], null, null, null, View_DirectorComponent_0, RenderType_DirectorComponent)), i1.ɵdid(1, 114688, null, 0, i2.DirectorComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DirectorComponentNgFactory = i1.ɵccf("app-director", i2.DirectorComponent, View_DirectorComponent_Host_0, {}, {}, []);
export { DirectorComponentNgFactory as DirectorComponentNgFactory };
